<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.change_phone.fields.phone.label')"
                    :placeholder="$t('forms.user.change_phone.fields.phone.placeholder')"
                    :isRequired="true"
                    type="text"
                    name="phone"
                    valuePath="mobile"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :label="$t('forms.user.change_phone.buttons.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin],

        props: {
            prefill: { type: Object, default: undefined },
        },

        methods: {
            submit() {
                this.submitForm(
                    UsersAPI.changePhone({ mobile: this.data.mobile }).then(() => {
                        this.$auth.reloadUser()
                    }),
                ).catch((error) => {
                    if (error.statusCode === 400) {
                        this.$toast.error(
                            this.$t(`forms.user.change_phone.errors.${error.error.message.replace('.', '_').toLowerCase()}`),
                        )
                    }
                })
            },

            prefillFormData() {
                const prefill = {
                    mobile: this.prefill?.mobile,
                }
                if (this.prefill) {
                    this.prefillData(prefill)
                }
            },
        },

        mounted() {
            this.$nextTick(() => {
                this.prefillFormData()
            })
        },
    }
</script>
